import { CopyValue } from '../utils/CopyValue';
import { type DOI } from '../utils/doi';

export function DOIReferenceURL({ doi }: { doi: DOI }) {
  if (doi.referenceURLs.length === 0) {
    return null;
  }

  return (
    <>
      {doi.referenceURLs.map((url) => (
        <CopyValue
          key={url}
          value={url}
          renderedValue={
            <a href={url} target="_blank" rel="noopener noreferrer">
              {url}
            </a>
          }
        />
      ))}
    </>
  );
}
